import Image from "next/legacy/image";
import channelTalk_desktop from "/public/images/landing/channelTalk/desktop.png";
import channelTalk_mobile from "/public/images/landing/channelTalk/mobile.png";
import * as S from "./ChannelTalkBtn.style";
import { sendLog } from "@/businessLogics/_common/logging";

export default function ChannelTalkBtn() {
  function clickChannelTalkButton() {
    sendLog("sw_contact_click");
  }
  return (
    <>
      <S.DesktopWrapper onClick={clickChannelTalkButton}>
        <S.Desktop className="channel-button">
          <Image
            src={channelTalk_desktop}
            alt={"channelTalkBtn"}
            width={210}
            height={110}
            quality={100}
            priority
          />
        </S.Desktop>
      </S.DesktopWrapper>
      <S.MobileWrapper>
        <S.Mobile>
          <S.EmptyDiv />
          <S.MobileImage
            onClick={clickChannelTalkButton}
            className="channel-button"
          >
            <Image
              src={channelTalk_mobile}
              alt={"channelTalkBtn"}
              width={54}
              height={54}
              unoptimized
              priority
            />
          </S.MobileImage>
        </S.Mobile>
      </S.MobileWrapper>
    </>
  );
}
